import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useShowLogin } from "../Context/modalContex";

const ProtectedRoute = ({ children }) => {
  const { accessToken, authStatus } = useSelector((state) => state.auth);
  const { showLogin, setShowLogin } = useShowLogin();

  useEffect(() => {
    if (authStatus !== "checking" && !accessToken) {
      setShowLogin(true);
    }
  }, [accessToken, authStatus, setShowLogin]);

  if (authStatus === "checking") return null;

  if (!accessToken && !showLogin) {
    return <Navigate to={"/"} />;
  }
  return children;
};

export default ProtectedRoute;
